import { useEffect, useRef, useState } from "react";
import { BsArrowLeft, BsArrowRight } from "react-icons/bs";
import ReactPaginate from "react-paginate";
import { useFilter } from "../../ApiS";

const Pagination = ({ pageCount }: { pageCount?: number }) => {
  const { handlePageClick, searchParams } = useFilter();

  const [selectedPage, setSelectedPage] = useState(
    parseInt(searchParams.get("page")!) - 1 || 0
  );

  useEffect(() => {
    setSelectedPage(parseInt(searchParams.get("page")!) - 1 || 0);
  }, [searchParams]);

  const onPageChange = (selectedItem: { selected: number }) => {
    handlePageClick(selectedItem);
    setSelectedPage(selectedItem.selected);
    window.location.reload();
  };

  return (
    <>
      {pageCount ? (
        <div className="flex justify-center my-3">
          <ReactPaginate
            className="pagination flex"
            previousLabel={
              <BsArrowRight className="text-slate-500 text-center my-auto h-full" />
            }
            nextLabel={
              <BsArrowLeft className="text-slate-500 text-center my-auto h-full" />
            }
            breakLabel="..."
            pageCount={pageCount || 0}
            marginPagesDisplayed={3}
            pageRangeDisplayed={2}
            onPageChange={onPageChange}
            pageClassName="select-none rounded-full bg-blue-800 text-white mx-1 w-6 h-6"
            pageLinkClassName="w-full h-full flex justify-center items-center"
            forcePage={selectedPage}
          />
        </div>
      ) : null}
    </>
  );
};

export default Pagination;
